import { AddonMode } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { STAddonMode } from '@tencent/slide-sdk-model';

// 插件模式 - sdk对上层类型映射
export const ADD_ON_MODE_MAP = new Map([
    [STAddonMode?.iframe, AddonMode.IFRAME],
    [STAddonMode?.normal, AddonMode.NORMAL],
]);
